export type Flavor = "purchased" | "manufactured" | "transferred";

interface FlavorInput {
  supplier: number | null;
  producesItem: number;
  location: number;
  components: { item: number; location: number; quantity: number }[];
}

/**
 * Mirror of the backend Source.flavor property. Display-only — the server's
 * computed flavor is authoritative once a source is saved. Three values,
 * derived purely from component shape (supplier presence is irrelevant):
 * no components = purchased, the relocation shape = transferred, otherwise
 * manufactured.
 */
export function computeFlavor(input: FlavorInput): Flavor {
  const hasSupplier = input.supplier != null;
  const n = input.components.length;

  if (
    !hasSupplier &&
    n === 1 &&
    input.components[0].item === input.producesItem &&
    input.components[0].location !== input.location &&
    Number(input.components[0].quantity) === 1
  ) {
    return "transferred";
  }
  if (n === 0) return "purchased";
  return "manufactured";
}
